export const twilioCountries = [
  { name: "United States", iso: "US", dial: "+1" },
  { name: "Canada", iso: "CA", dial: "+1" },
  { name: "United Kingdom", iso: "GB", dial: "+44" },
  { name: "Australia", iso: "AU", dial: "+61" },
  { name: "Germany", iso: "DE", dial: "+49" },
  { name: "France", iso: "FR", dial: "+33" },
  { name: "Brazil", iso: "BR", dial: "+55" },
  { name: "Mexico", iso: "MX", dial: "+52" },
  { name: "India", iso: "IN", dial: "+91" },
  { name: "Japan", iso: "JP", dial: "+81" },
  { name: "Italy", iso: "IT", dial: "+39" },
  { name: "Netherlands", iso: "NL", dial: "+31" },
  { name: "Spain", iso: "ES", dial: "+34" },
  { name: "Sweden", iso: "SE", dial: "+46" },
  { name: "Switzerland", iso: "CH", dial: "+41" },
  { name: "Belgium", iso: "BE", dial: "+32" },
  { name: "Denmark", iso: "DK", dial: "+45" },
  { name: "Finland", iso: "FI", dial: "+358" },
  { name: "Ireland", iso: "IE", dial: "+353" },
  { name: "Norway", iso: "NO", dial: "+47" },
  { name: "Austria", iso: "AT", dial: "+43" },
  { name: "Portugal", iso: "PT", dial: "+351" },
  { name: "South Africa", iso: "ZA", dial: "+27" },
  { name: "Singapore", iso: "SG", dial: "+65" },
  { name: "Hong Kong", iso: "HK", dial: "+852" },
  { name: "New Zealand", iso: "NZ", dial: "+64" },
  { name: "Israel", iso: "IL", dial: "+972" },
  { name: "Poland", iso: "PL", dial: "+48" },
  { name: "Czech Republic", iso: "CZ", dial: "+420" },
  { name: "Hungary", iso: "HU", dial: "+36" },
  { name: "Romania", iso: "RO", dial: "+40" },
  { name: "Turkey", iso: "TR", dial: "+90" },
  { name: "Lithuania", iso: "LT", dial: "+370" },
  { name: "Latvia", iso: "LV", dial: "+371" },
  { name: "Estonia", iso: "EE", dial: "+372" },
  { name: "Slovakia", iso: "SK", dial: "+421" },
  { name: "Slovenia", iso: "SI", dial: "+386" },
  { name: "Croatia", iso: "HR", dial: "+385" },
  { name: "Greece", iso: "GR", dial: "+30" },
  { name: "Bulgaria", iso: "BG", dial: "+359" },
];
